import { render, staticRenderFns } from "./ButtonWithDialog.vue?vue&type=template&id=1894f5b6"
import script from "./ButtonWithDialog.vue?vue&type=script&lang=js"
export * from "./ButtonWithDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports